document.addEventListener('DOMContentLoaded', function() {
    const cartDrawerElement = document.querySelector('#CartDrawer');

    if (cartDrawerElement) {
        cartDrawerElement.addEventListener('click', function(event) {
            const target = event.target;
            if (target && target.classList.contains('upsell-add-to-cart-btn')) {
                event.preventDefault();
                const variantId = target.getAttribute('data-product-variant-id');
                addProductToCart(variantId);
            }
        });
    }
});

function addProductToCart(variantId) {
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ 
            items: [{ id: variantId, quantity: 1 }]
        })
    })
    .then(response => response.json())
    .then(data => {
        if (!data.error) {
            refreshCartDrawer();
        } else {
            console.error('Error adding item:', data.error);
        }
    })
    .catch((error) => {
        console.error('Error:', error);
    });
}

function refreshCartDrawer() {
    fetch(`${window.location.origin}/cart?section_id=cart-drawer`)
        .then(response => response.text())
        .then(text => {
            const html = new DOMParser().parseFromString(text, 'text/html');
            const newCartDrawerContent = html.querySelector('#CartDrawer');

            if (newCartDrawerContent) {
                const cartDrawerElement = document.querySelector('#CartDrawer');
                if (cartDrawerElement) {
                    cartDrawerElement.innerHTML = newCartDrawerContent.innerHTML;
                }
            }

            // Open the cart drawer if it's not already open
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && !cartDrawer.classList.contains('active')) {
                cartDrawer.open();
            }
        })
        .catch(error => console.error('Error:', error));
}
